<div class="cliente-analise-financeira">
    <sgt-accordion [settings]="{ isCollapsed: true }">
        <h6 header class="m-0">Análise Financeira</h6>
        
        <ng-template [ngIf]="isLoading">
            <p class="cliente-analise-financeira-loading">
                <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando Análise Financeira
            </p>
        </ng-template>
        
        <ng-template [ngIf]="!isLoading && cliente">
            <sgt-cliente-analise-financeira-form
                [cliente]="cliente"
                [canEdit]="false"
                [showCliente]="showCliente"
                [showRepresentante]="showRepresentante">
            </sgt-cliente-analise-financeira-form>
        </ng-template>
    </sgt-accordion>   
</div>

